import car1_before from "./car1_before.jpg";
import car1_after from "./car1_after.jpg";
import car2_before from "./car2_before.jpg";
import car2_after from "./car2_after.jpg";
import car3_before from "./car3_before.jpg";
import car3_after from "./car3_after.jpg";
import car4_before from "./car4_before.jpg";
import car4_after from "./car4_after.jpg";
import car5_before from "./car5_before.jpg";
import car5_after from "./car5_after.jpg";
import car6_before from "./car6_before.jpg";
import car6_after from "./car6_after.jpg";

export const images = {
  car1: {
    before: car1_before,
    after: car1_after,
  },
  car2: {
    before: car2_before,
    after: car2_after,
  },
  car3: {
    before: car3_before,
    after: car3_after,
  },
  car4: {
    before: car4_before,
    after: car4_after,
  },
  car5: {
    before: car5_before,
    after: car5_after,
  },
  car6: {
    before: car6_before,
    after: car6_after,
  },
}